// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"522":"c3124e31","1227":"c3124e31","1473":"c3124e31","2498":"c3124e31","3057":"c3124e31","3132":"c3124e31","4494":"c3124e31","4622":"c3124e31","5216":"c3124e31","5890":"c3124e31","6390":"c3124e31"}[chunkId] + ".chunk.css";
};